<template>
  <div>
    <modals-container
      @confirmAdd="passConfirmAdd"
      @confirmDelete="passConfirmDelete"
      @updateContractNumber="updateContractNumber"
      @confirmAutomaticContract="passConfirmAutomaticContract"
    ></modals-container>

    <h5 class="mt-4" v-if="Object.entries(consolidationData).length === 0">
      No data for
      <router-link
        :to="{ name: 'EditProject', params: { id: currentProject.id } }"
        >{{ currentProject.name }}
      </router-link>
    </h5>

    <div v-if="Object.entries(consolidationData).length !== 0">
      <h5 class="mb-4">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <div class="input-group-icon right">
                <div class="input-icon"><i class="fa fa-search"></i></div>
                <input
                  v-model="craftsmenFilter"
                  @keyup="filterCraftsmen"
                  class="form-control"
                  type="text"
                  :placeholder="$t('message.filterCraftsmen')"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <router-link
              :to="{ name: 'EditProject', params: { id: currentProject.id } }"
            >
              {{ currentProject.name }}
            </router-link>
          </div>
        </div>
      </h5>

      <div class="tableScroll mb-4">
        <div class="wrapper">
          <div class="scroller" v-bind:style="styles">
            <table
              class="table table-bordered"
              v-if="visibleConsolidationData.length && setColoring"
            >
              <thead>
                <tr>
                  <th
                    class="sticky-col first"
                    style="border: 0 !important"
                  ></th>
                  <th
                    class="sticky-col second"
                    style="border: 0 !important; "
                  ></th>

                  <th
                    class="text-center"
                    style="vertical-align: top"
                    v-for="(row, i) in visibleConsolidationData"
                    :key="'A' + i"
                      :class="{
                      lateWithInput: row['lateWithInput'],
                      lateWithInputCurrentMonth:
                        row['lateWithInputCurrentMonth'],
                        zeroValueAdded: row['zeroValueAdded'],
                        closedSheet: row['closedSheet'],
                        costsAdded: row['costsAdded'],
                    }"
                  >
                    <router-link
                      v-if="!showLink"
                      :to="{
                        name: 'ActualCostsWork',
                        params: {
                          id: row.id,
                          type: 'personnel',
                          heading: 'work',
                          lastRoute: 'Dashboard',
                          projectId: currentProject.id,
                        },
                      }"
                    >
                      {{ row.company_name }}
                    </router-link>
                    <p v-if="showLink">{{ row.company_name }}</p>
                    <hr style="margin: 2px" />
                    <span style="font-weight: normal">{{ row.job_name }}</span>
                  </th>
                </tr>
                <tr>
                  <th
                    class="sticky-col first"
                    style="border: 0 !important"
                  ></th>
                  <th class="sticky-col second" style="border: 0 !important; white-space: nowrap;">
                    <b>{{ $t("message.contractNumber") }}:</b>
                  </th>
                  <th
                    class="center-vertical text-center"
                    style="background-color: #dbd7d7"
                    @click="updateContractNumberDialog(row)"
                    v-for="(row, i) in visibleConsolidationData"
                    :key="'B' + i"
                  >
                    {{ row.contract_number }}
                  </th>
                </tr>
                <tr>
                  <td class="sticky-col first gray">
                    <b>{{ $t("message.targetCost") }}</b>
                  </td>
                  <td class="sticky-col second gray" style="text-align: right">
                    <b>{{ formatNumber(currentProject.target_cost) }}</b>
                  </td>
                  <td
                    class="center-vertical text-right"
                    style="width: 110px"
                    v-for="(row, i) in visibleConsolidationData"
                    :key="'C' + i"
                  >
                    <b>{{ formatNumber(row.target_cost) }}</b>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="sticky-col first gray">
                    <b>{{ $t("message.staticBudget") }}</b>
                  </td>
                  <td class="sticky-col second gray" style="text-align: right">
                    <b>{{ formatNumber(currentProject.static_budget) }}</b>
                  </td>
                  <td
                    class="center-vertical text-right"
                    v-for="(row, i) in visibleConsolidationData"
                    :key="'D' + i"
                  >
                    <b>{{ formatNumber(row.static_budget) }}</b>
                  </td>
                </tr>
                <!-- <tr>
                  <td class="sticky-col first gray" style="font-size: 12px">
                    {{ $t("message.deviationFromTargetCosts") }}
                  </td>
                  <td
                    class="sticky-col second gray"
                    style="font-size: 12px; text-align: right"
                  >
                    {{
                      calculateDeviation(
                        currentProject.static_budget,
                        currentProject.target_cost
                      ).toLocaleString("en")
                    }}%
                  </td>

                  In case first character in the cell is not negative number or undefined,
                                     set the cell to be red (the value is positive)
                  <td
                    class="center-vertical fontSmall text-right"
                    v-for="(row, i) in visibleConsolidationData"
                    :key="'E' + i"
                    v-bind:class="{
                      isPositive:
                        calculateDeviation(
                          row.static_budget,
                          row.target_cost
                        )[0] != '-' &&
                        calculateDeviation(
                          row.static_budget,
                          row.target_cost
                        )[0] != 'U',
                    }"
                  >
                    {{
                      calculateDeviation(
                        row.static_budget,
                        row.target_cost
                      ).toLocaleString("en")
                    }}%
                  </td>
                </tr>
                <tr>
                  <td class="sticky-col first gray">
                    <b>{{ $t("message.dynamicBudget") }}</b>
                  </td>
                  <td class="sticky-col second gray" style="text-align: right">
                    <b>{{ formatNumber(currentProject.dynamic_budget) }}</b>
                  </td>
                  <td
                    class="center-vertical text-right"
                    v-for="(row, i) in visibleConsolidationData"
                    :key="'F' + i"
                  >
                    <b>{{ formatNumber(row.dynamic_budget) }}</b>
                  </td>
                </tr>
                <tr>
                  <td class="sticky-col first gray" style="font-size: 12px">
                    {{ $t("message.deviationFromBudget") }}
                  </td>
                  <td
                    class="sticky-col second gray"
                    style="font-size: 12px; text-align: right"
                  >
                    {{
                      calculateDeviation(
                        currentProject.dynamic_budget,
                        currentProject.static_budget
                      ).toLocaleString("en")
                    }}%
                  </td>
                   In case first character in the cell is not negative number or undefined,
                                     set the cell to be red (the value is positive)

                  <td
                    class="center-vertical fontSmall text-right"
                    v-for="(row, i) in visibleConsolidationData"
                    :key="'G' + i"
                    v-bind:class="{
                      isPositive:
                        calculateDeviation(
                          row.dynamic_budget,
                          row.static_budget
                        )[0] != '-' &&
                        calculateDeviation(
                          row.dynamic_budget,
                          row.static_budget
                        )[0] != 'U',
                    }"
                  >
                    {{
                      calculateDeviation(
                        row.dynamic_budget,
                        row.static_budget
                      ).toLocaleString("en")
                    }}%
                  </td>
                </tr> -->
                <tr>
                  <td class="sticky-col first gray">
                    <b>{{ $t("message.actualCosts") }}</b>
                  </td>
                  <td class="sticky-col second gray" style="text-align: right">
                    <b>{{ formatNumber(currentProject.actual_costs) }}</b>
                  </td>
                  <td
                    class="center-vertical text-right"
                    v-for="(row, i) in visibleConsolidationData"
                    :key="'H' + i"
                  >
                    <b>{{ formatNumber(row.actual_costs) }}</b>
                  </td>
                </tr>
                <tr>
                  <td class="sticky-col first gray">
                    <b>{{ $t("message.totalInvoiced") }}</b>
                  </td>
                  <td class="sticky-col second gray" style="text-align: right">
                    <b>{{ formatNumber(currentProject.total_invoiced) }}</b>
                  </td>
                  <td
                    class="center-vertical text-right"
                    v-for="(row, i) in visibleConsolidationData"
                    :key="'I' + i"
                  >
                    <b>{{ formatNumber(row.total_invoiced) }}</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <ul class="legend">
            <li><span class="lateWithInput"></span>{{ $t("message.lateWithInput") }}</li>
            <li><span class="lateWithInputCurrentMonth"></span> {{ $t("message.lateWithInputCurrentMonth") }}</li>
            <li><span class="zeroValueAdded"></span> {{ $t("message.zeroValueAdded") }}</li>
            <li><span class="closedSheet"></span> {{ $t("message.sheetClosed") }}</li>
            <li><span class="costsAdded"></span>{{ $t("message.costsAdded") }}</li>
          </ul>
        </div>
      </div>

      <stacked-bar-chart
        :options="stackedOptions"
        :chartData="stackedChartDataCollection"
        :key="'J' + componentKeyStackedBar"
      ></stacked-bar-chart>

      <!-- <horizontal-bar-chart :options="chartOptions"
                                  :chart-data="horizontalBarDataCollection"></horizontal-bar-chart> -->
      <b>{{ $t("message.rollingForecast") }}</b>
      <!-- <bar-chart :options="chartOptions"
                       :chart-data="barDataCollection"></bar-chart> -->

      <mixed-chart
        :chartData="mixedChartData"
        :options="mixedChartOptions"
        :key="'K' + componentKeyMixedChart"
      ></mixed-chart>
    </div>
  </div>
</template>

<script>
import StackedBarChart from "../../../charts/StackedBarChart";
// import HorizontalBarChart  from '../../../charts/HorizontalBarChart'
import MixedChart from "../../../charts/MixedChart";
import ContractNumberModal from "../../../modals/ContractNumberModal";
import OkModal from "../../../modals/OkModal";
export default {
  name: "Consolidation",
  data() {
    return {
      componentKeyMixedChart: 0,
      componentKeyStackedBar: 0,
      craftsmenFilter: "",
      setColoring: false,
    };
  },
  props: [
    "stackedOptions",
    "stackedChartDataCollection",
    "chartOptions",
    "horizontalBarDataCollection",
    "barDataCollection",
    "consolidationData",
    "currentProject",
    "showLink",
    "mixedChartOptions",
    "mixedChartData",
    "lastMonthsOfInsertion",
  ],
  components: {
    //   HorizontalBarChart,
    //   BarChart,
    MixedChart,
    StackedBarChart,
  },
  created() {
    // get data for coloring of dashboard table
    this.getDataForColoring();
  },
  computed: {
    styles: function () {
      let width = this.visibleConsolidationData.length * 123;
      if (screen.width <= 1366 && this.visibleConsolidationData.length > 4)
        width = 440;
      if (screen.width > 1366 && this.visibleConsolidationData.length > 8)
        width = 870;
      return {
        width: width + "px",
      };
    },
    visibleConsolidationData: function () {
      if (this.consolidationData.length) {
        let visibleConsolidationData = this.consolidationData.filter(
          (i) => i.filter_matched === true
        );
        return visibleConsolidationData;
      }
      return null;
    },
  },
  methods: {
    getDataForColoring() {
      this.get(
        this.apiPrefix,
        this.projectApiUrl + "get-last-month-of-insert-per-sheet/",
        this.currentProject.id
      ).then((resp) => {
        this.setDashboardColumColorClass(
          resp.data.data,
          this.visibleConsolidationData
        );
      });
    },
    setDashboardColumColorClass(lastMonthsOfInsert) {
      this.setColoring = false;
      const currentMonth = this.$moment();
      const startOfTheMonth = this.$moment().startOf("month");
      const endOfTheMonth = this.$moment().endOf("month");
      if (endOfTheMonth.diff(currentMonth, "days") <= 5) {
        for (const row of lastMonthsOfInsert) {
          const difference = startOfTheMonth.diff(
            row.last_month,
            "months",
            true
          );
          if (difference >= 1) {
            const index = this.findByProperty(
              this.consolidationData,
              "id",
              row.sheet
            );
            if (index !== -1) {
              this.consolidationData[index]["lateWithInputCurrentMonth"] = true;
            }
          }
          if (difference >= 2) {
            const index = this.findByProperty(
              this.consolidationData,
              "id",
              row.sheet
            );
            if (index !== -1) {
              this.consolidationData[index]["lateWithInput"] = true;
            }
          }
          if (row.total_costs === 0 && difference <= 1) {
            const index = this.findByProperty(
              this.consolidationData,
              "id",
              row.sheet
            );
            if (index !== -1) {
              this.consolidationData[index]["zeroValueAdded"] = true;
            }
          }
          if (row.total_costs !== 0 && difference <= 1 && !row.is_closed) {
            const index = this.findByProperty(
              this.consolidationData,
              "id",
              row.sheet
            );
            if (index !== -1) {
              this.consolidationData[index]["costsAdded"] = true;
            }
          }
          if (row.is_closed) {
            const index = this.findByProperty(
              this.consolidationData,
              "id",
              row.sheet
            );
            if (index !== -1) {
              this.consolidationData[index]["closedSheet"] = true;
            }
          }
        }
      } else {
        for (const row of lastMonthsOfInsert) {
          const difference = startOfTheMonth.diff(
            row.last_month,
            "months",
            true
          );
          if (difference >= 2) {
            const index = this.findByProperty(
              this.consolidationData,
              "id",
              row.sheet
            );
            if (index !== -1) {
              this.consolidationData[index]["lateWithInput"] = true;
            }
          }
          if (row.total_costs === 0 && difference <= 1) {
            const index = this.findByProperty(
              this.consolidationData,
              "id",
              row.sheet
            );
            if (index !== -1) {
              this.consolidationData[index]["zeroValueAdded"] = true;
            }
          }
          if (row.total_costs !== 0 && difference <= 1 && !row.is_closed) {
            const index = this.findByProperty(
              this.consolidationData,
              "id",
              row.sheet
            );
            if (index !== -1) {
              this.consolidationData[index]["costsAdded"] = true;
            }
          }
          if (row.is_closed) {
            const index = this.findByProperty(
              this.consolidationData,
              "id",
              row.sheet
            );
            if (index !== -1) {
              this.consolidationData[index]["closedSheet"] = true;
            }
          }
        }
      }
      this.setColoring = true;
    },
    passConfirmAdd(data) {
      this.$emit("confirmAdd", data);
    },
    passConfirmDelete(data) {
      this.$emit("confirmDelete", data);
    },
    passConfirmAutomaticContract(data) {
      this.$emit("confirmAutomaticContract", data);
    },
    updateContractNumberDialog(sheet) {
      this.$modal.show(
        ContractNumberModal,
        {
          contractNumber: sheet.contract_number,
          sheetId: sheet.id,
          heading: this.$t("message.updateContractNumber"),
        },
        {
          width: this.modalWidth(),
          height: "auto",
        }
      );
    },
    updateContractNumber(data) {
      this.update(this.apiPrefix, this.sheetApiUrl, data.sheetId, {
        contract_number: data.contractNumber,
      })
        .then(() => {
          this.$modal.show(
            OkModal,
            {
              text: this.$t("message.contractNoSuccesfullyUpdated"),
              modalClass: this.modalClasses.okSuccessClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
          this.$emit("refreshConsolidation");
        })
        .catch(() => {
          this.$modal.show(
            OkModal,
            {
              text: this.$t("message.oopsSomethingWentWrong"),
              modalClass: this.modalClasses.okErrorClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
        });
    },
    filterCraftsmen() {
      for (let i = 0; i < this.consolidationData.length; i++) {
        if (
          this.consolidationData[i].company_name_lower.includes(
            this.craftsmenFilter.toLowerCase()
          )
        )
          this.consolidationData[i].filter_matched = true;
        else this.consolidationData[i].filter_matched = false;
      }
    },
    calculateDeviation(static_budget, target_cost) {
      if (target_cost !== 0)
        return this.formatNumber(
          ((static_budget - target_cost) / target_cost) * 100
        );
      else return `${this.$t("message.notPossibleToCalculate")} `;
    },
    addThousandSeparator(num) {
      if (num !== null && num !== undefined) return num.toLocaleString("en");
    },
    formatNumber(input) {
      // format is function in generalMixin.js
      return this.format(input);
    },
    isCharNumber(c) {
      return c >= "0" && c <= "9";
    },
    triggerReloadMixedChart() {
      this.componentKeyMixedChart++;
    },
    triggerReloadStackedBar() {
      this.componentKeyStackedBar++;
    },
  },
};
</script>

<style scoped>
.legend {
  list-style: none;
}
.legend li {
  float: left;
  margin-right: 10px;
}
.legend span {
  border: 1px solid #ccc;
  float: left;
  width: 20px;
  height: 20px;
  margin: 2px;
}
.isPositive {
  background: #fcc3bf;
}
.center-vertical {
  vertical-align: middle;
}
.fontSmall {
  font-size: 11px;
}
.tableScroll {
  height: auto;
  overflow-x: auto;
}
.borderTop {
  border-top: 2px solid;
}
.borderRight {
  border-right: 2px solid;
}
.wrapper {
  position: relative;
}
.scroller {
  margin-left: 355px;
  overflow-x:scroll;
  overflow-y: visible;
  padding-bottom: 5px;
}
.gray {
  background: #e8e3e3;
}
/* @media screen and ( max-width: 800px) {
        .scroller{
           width: 500px;
        }
    } */
/* @media screen and ( min-width: 1400px) {
        .scroller{
           width: 1120px;
        }
    } */
.table .sticky-col {
  border-left: solid 1px #ddefef;
  border-right: solid 1px #ddefef;
  position: absolute;
  top: auto;
}
.table .first {
  left: 0;
  width: 210px;
}
.table .second {
  left: 210px;
  width: 150px;
}
.table .head {
  background-color: #ddefef;
  border: none;
  color: #336b6b;
  padding: 10px;
  text-align: left;
  text-shadow: 1px 1px 1px #fff;
  white-space: nowrap;
  width:123px;
}
.table tbody td {
  color: #333;
  padding: 10px;
  text-shadow: 1px 1px 1px #fff;
  white-space: nowrap;
  width: 123px;
}
.lateWithInput {
  background-color: #fcc3bf;
}
.lateWithInputCurrentMonth {
  background-color: #f7b82f;
}
.zeroValueAdded {
  background-color: #fcff9e;
}
/*.sheetClosed {*/
  /*background-color: #fc5953;*/
/*}*/

.closedSheet {
  background-color: #fc5953;
}

.closedSheet a{
  color: white;
}

.costsAdded {
  background-color: #53fca5;
}
/* td {
        min-width: 50px;
        width: 130px;
        height: 60px;
        padding: 5px;
    } */
.fixed {
  position: absolute;
  background: #aaa;
}
@media screen and (max-width: 1366px) {
  .secondColumn {
    left: 125px;
    width: 120px;
  }
}
@media screen and (min-width: 1366px) {
  .secondColumn {
    left: 125px;
    width: 160px;
  }
}
</style>